import { Shield, Mail, Lock, Eye, UserCheck, FileText } from 'lucide-react';

export const PolitiqueConfidentialite = () => {
  return (
    <div data-testid="politique-confidentialite-page">
      {/* Hero */}
      <section className="bg-[#0B1F3A] py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <Shield className="mx-auto text-[#C8A75A] mb-4" size={40} />
          <h1 className="font-serif-heading text-4xl font-semibold text-white mb-4">
            Politique de confidentialité
          </h1>
          <div className="w-16 h-0.5 bg-[#C8A75A] mx-auto mb-4"></div>
          <p className="text-[#F5F5F5]/80 text-sm">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>
      </section>

      {/* Contenu */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          
          {/* Introduction */}
          <div className="mb-10 p-6 bg-[#F5F5F5] border-l-4 border-[#C8A75A]">
            <p className="text-[#4A4A4A]">
              L'Institut BIA s'engage à protéger la vie privée des utilisateurs de son site. 
              Cette politique explique quelles données sont collectées, comment elles sont utilisées, 
              et vos droits conformément au Règlement Général sur la Protection des Données (RGPD).
            </p>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4 flex items-center gap-3">
              <FileText className="text-[#C8A75A]" size={24} />
              1. Responsable du traitement
            </h2>
            <p className="text-[#4A4A4A] mb-3">
              Le responsable du traitement des données personnelles est :
            </p>
            <div className="bg-[#F5F5F5] p-6">
              <p className="text-[#4A4A4A] mb-1"><strong className="text-[#0B1F3A]">Institut BIA</strong></p>
              <p className="text-[#4A4A4A] mb-1">Saint-Denis (93)</p>
              <p className="text-[#4A4A4A]">Email : contact@institut-bia.fr</p>
            </div>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4 flex items-center gap-3">
              <UserCheck className="text-[#C8A75A]" size={24} />
              2. Délégué à la Protection des Données (DPO)
            </h2>
            <p className="text-[#4A4A4A] mb-3">
              Pour toute question relative à la protection de vos données personnelles :
            </p>
            <div className="bg-[#0B1F3A] p-6 text-white">
              <p className="mb-2 flex items-center gap-2">
                <Mail className="text-[#C8A75A]" size={18} />
                <a href="mailto:postmaster@institut-bia.fr" className="text-[#C8A75A] hover:underline">
                  postmaster@institut-bia.fr
                </a>
              </p>
              <p className="text-[#F5F5F5]/70 text-sm">
                Notre DPO répondra à vos demandes dans un délai maximum de 30 jours.
              </p>
            </div>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4 flex items-center gap-3">
              <Eye className="text-[#C8A75A]" size={24} />
              3. Données collectées
            </h2>
            <p className="text-[#4A4A4A] mb-4">
              Nous collectons uniquement les données nécessaires aux finalités suivantes :
            </p>
            <div className="space-y-4">
              <div className="border border-[#E6E6E6] p-4">
                <h3 className="font-semibold text-[#0B1F3A] mb-2">Formulaire de candidature étudiant</h3>
                <p className="text-[#4A4A4A] text-sm">
                  Nom, prénom, date de naissance, coordonnées, adresse, niveau d'études, motivation.
                </p>
              </div>
              <div className="border border-[#E6E6E6] p-4">
                <h3 className="font-semibold text-[#0B1F3A] mb-2">Formulaire de contact employeur</h3>
                <p className="text-[#4A4A4A] text-sm">
                  Nom de l'entreprise, contact, coordonnées, secteur d'activité, besoin.
                </p>
              </div>
              <div className="border border-[#E6E6E6] p-4">
                <h3 className="font-semibold text-[#0B1F3A] mb-2">Fiche de positionnement</h3>
                <p className="text-[#4A4A4A] text-sm">
                  Informations pédagogiques, compétences auto-évaluées, projet professionnel.
                </p>
              </div>
              <div className="border border-[#E6E6E6] p-4">
                <h3 className="font-semibold text-[#0B1F3A] mb-2">Livret de suivi pédagogique</h3>
                <p className="text-[#4A4A4A] text-sm">
                  Suivi de formation, évaluations, présences, événements pédagogiques.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4 flex items-center gap-3">
              <Lock className="text-[#C8A75A]" size={24} />
              4. Finalités et bases légales
            </h2>
            <ul className="space-y-3 text-[#4A4A4A]">
              <li>• <strong className="text-[#0B1F3A]">Gestion des candidatures</strong> (base : mesures précontractuelles)</li>
              <li>• <strong className="text-[#0B1F3A]">Suivi pédagogique</strong> (base : exécution du contrat)</li>
              <li>• <strong className="text-[#0B1F3A]">Communication institutionnelle</strong> (base : intérêt légitime)</li>
              <li>• <strong className="text-[#0B1F3A]">Obligations légales</strong> (base : conformité RNCP, Qualiopi)</li>
            </ul>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              5. Durée de conservation
            </h2>
            <ul className="space-y-2 text-[#4A4A4A]">
              <li>• Candidatures non retenues : 2 ans</li>
              <li>• Dossiers apprenants : 5 ans après la fin du contrat</li>
              <li>• Données financières et administratives : 10 ans</li>
              <li>• Cookies : 13 mois maximum</li>
            </ul>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              6. Vos droits
            </h2>
            <p className="text-[#4A4A4A] mb-4">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <div className="grid md:grid-cols-2 gap-4">
              {[
                { title: "Droit d'accès", desc: "Consulter vos données personnelles" },
                { title: "Droit de rectification", desc: "Corriger des données inexactes" },
                { title: "Droit à l'effacement", desc: "Demander la suppression de vos données" },
                { title: "Droit d'opposition", desc: "Refuser certains traitements" },
                { title: "Droit à la portabilité", desc: "Récupérer vos données" },
                { title: "Droit à la limitation", desc: "Limiter le traitement" }
              ].map((right, i) => (
                <div key={i} className="bg-[#F5F5F5] p-4">
                  <h3 className="font-semibold text-[#0B1F3A] text-sm mb-1">{right.title}</h3>
                  <p className="text-[#4A4A4A] text-xs">{right.desc}</p>
                </div>
              ))}
            </div>
            <p className="text-[#4A4A4A] mt-4">
              Pour exercer vos droits, contactez notre DPO : 
              <a href="mailto:postmaster@institut-bia.fr" className="text-[#C8A75A] hover:underline ml-1">
                postmaster@institut-bia.fr
              </a>
            </p>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              7. Sécurité des données
            </h2>
            <p className="text-[#4A4A4A]">
              L'Institut BIA met en œuvre toutes les mesures techniques et organisationnelles appropriées 
              pour garantir la sécurité et la confidentialité de vos données personnelles (chiffrement, 
              contrôles d'accès, sauvegardes régulières).
            </p>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              8. Cookies
            </h2>
            <p className="text-[#4A4A4A]">
              Ce site utilise uniquement des cookies techniques strictement nécessaires à son 
              fonctionnement. Aucun cookie de traçage ou publicitaire n'est déposé sans votre consentement.
            </p>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              9. Réclamation
            </h2>
            <p className="text-[#4A4A4A]">
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une 
              réclamation auprès de la <strong>CNIL</strong> : 
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#C8A75A] hover:underline ml-1">
                www.cnil.fr
              </a>
            </p>
          </div>

          {/* Contact final */}
          <div className="mt-12 p-8 bg-[#0B1F3A] text-white text-center">
            <Shield className="mx-auto text-[#C8A75A] mb-4" size={32} />
            <h3 className="font-serif-heading text-xl font-semibold mb-3">
              Une question sur vos données ?
            </h3>
            <p className="text-[#F5F5F5]/80 mb-4 text-sm">
              Contactez notre Délégué à la Protection des Données
            </p>
            <a 
              href="mailto:postmaster@institut-bia.fr" 
              className="inline-flex items-center gap-2 bg-[#C8A75A] text-[#0B1F3A] hover:bg-[#DDBF78] rounded-none px-6 py-3 transition-colors font-medium"
            >
              <Mail size={18} /> postmaster@institut-bia.fr
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PolitiqueConfidentialite;
